<template>
	<div>
		<router-view></router-view>
	</div>
</template>

<script>
    export default {
        name: 'transactionHome',
        data () {
            return {

            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/transactions/home.vue